import { computed } from 'vue';
import { getSimpleChoiceMeta } from '@/utils/getSimpleChoiceMeta/getSimpleChoiceMeta';
import {
  SIMPLE_CHOICE,
  SIMPLE_CHOICE_META,
} from '@/features/ChoicesLists/Simple/types';
import { useHauInputStore } from '@/features/Sparten/hau/useInputStore';
import { useHauContractStore } from '@/features/Sparten/hau/useContractStore';

export const hasFahrradDiebstahlAndRequiresAmount = () =>
  getSimpleChoiceMeta(
    SIMPLE_CHOICE.FAHRRADDIEBSTAHL,
    SIMPLE_CHOICE_META.FAHRRADDIEBSTAHL_REQUIRES_SUM,
  ).includes(useHauInputStore().fahrraddiebstahl);

export const hasFahrradDiebstahlAndRequiresAmountReactive = computed(() =>
  hasFahrradDiebstahlAndRequiresAmount(),
);

export const isFertighaus = computed(() =>
  getSimpleChoiceMeta(
    SIMPLE_CHOICE.BAUARTKLASSE,
    SIMPLE_CHOICE_META.BAUARTKLASSE_IS_FERTIGHAUS,
  ).includes(useHauInputStore().bauartklasse),
);

export const hasElementarversicherung = computed(
  () => useHauInputStore().elementarversicherung,
);

export const hasGlasversicherung = computed(
  () => useHauInputStore().glasversicherung,
);

export const hasGlasDamage = computed(
  () =>
    hasGlasversicherung.value &&
    useHauContractStore().vorschaden.vorschadenGlas,
);

export const hasElementarDamage = computed(
  () =>
    hasElementarversicherung.value &&
    useHauContractStore().vorschaden.vorschadenElementar,
);
